var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("travel-service-menu"),
      _c("travel-service-additional-parameters-dialog", {
        attrs: { dialog: _vm.dialog, model: _vm.dialogModel },
        on: {
          "update:dialog": function($event) {
            _vm.dialog = $event
          },
          saved: _vm.downloadParamList
        }
      }),
      _c("h1", [
        _vm._v(_vm._s(_vm.$t("travelService.additionalParametersList")))
      ]),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  attrs: { block: "", color: "accent" },
                  on: {
                    click: function($event) {
                      _vm.dialog = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("global.add")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-data-table",
        {
          attrs: { headers: _vm.headers, items: _vm.additionalParameters },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function(props) {
                return [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-left" },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: {
                                              disabled:
                                                props.item.ordinate === 1 ||
                                                _vm.$store.getters[
                                                  "Ajax/loading"
                                                ],
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.moveUp(props.item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v("fa-arrow-alt-circle-up")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.moveUp")) + " ")]
                        ),
                        _vm._v(" " + _vm._s(props.item.ordinate) + " "),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: {
                                              disabled:
                                                props.item.ordinate ===
                                                  _vm.additionalParameters
                                                    .length ||
                                                _vm.$store.getters[
                                                  "Ajax/loading"
                                                ],
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.moveDown(props.item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v("fa-arrow-alt-circle-down")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("global.moveDown")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(" " + _vm._s(props.item.name) + " ")
                    ]),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(" " + _vm._s(props.item.default_value) + " ")
                    ]),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            props.item.is_required
                              ? _vm.$t("global.required")
                              : _vm.$t("global.notRequired")
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "td",
                      { staticClass: "text-center" },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.edit(props.item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_c("v-icon", [_vm._v("edit")])],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.remove(props.item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_c("v-icon", [_vm._v("delete")])],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")]
                        )
                      ],
                      1
                    )
                  ])
                ]
              }
            }
          ])
        },
        [
          _c(
            "v-alert",
            {
              attrs: {
                slot: "no-data",
                value: _vm.loaded,
                color: "info",
                icon: "info"
              },
              slot: "no-data"
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("settings.travelService.noAcceptancePersons")) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-alert",
        {
          attrs: {
            color: "info",
            value: _vm.approvalUsers.length > 0,
            icon: "info"
          }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("settings.travelService.automaticApprovalInfo")) +
              " "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }